import axios from "axios";
import { successHandling } from "../helpers/successHandling";
import TextNoty from "../helpers/textNoty";
import { nubisUrl, url } from "@/apis/apiSetup";
import localforage from "localforage";

export const uploadFileToNubisDriveAPI = async (
  dataFromS3,
  file,
  md5Value,
  parentId,
  t,
  successfulText,
  onClose,
  setRefreshCapacity,
  reloadTable,
  setReturnValue,
  setDisabled,
  target,
  extra = {}
) => {
  try {
    const companyId = await localforage.getItem("userCompanyID");
    const token = await localforage.getItem("token");

    await axios({
      url: url + `/api/v1/drive/file/create` + `?company_id=${companyId}`,
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        acceptlanguage: "zh_cn"
      },
      method: "POST",
      data: {
        company_id: companyId,
        name: file.name,
        extension: file.name.split(".").pop(),
        mime_type: file.type,
        size: file.size,
        s3_path: dataFromS3.Key,
        md5: md5Value,
        parent_id: parentId,
        target,
        ...extra
      }
    });
    if (!setReturnValue) {
      successHandling(t, successfulText);
    }
    setRefreshCapacity(true);
    if (setDisabled) {
      setDisabled(false);
    }
    reloadTable();
    onClose(); // close the upload dialog
    return true;
  } catch (error) {
    if (setDisabled) {
      setDisabled(false);
    }
    if (error.response?.data?.errors?.size?.[0] === "storage_space_exceeded") {
      TextNoty(t("dialog.storageSpaceExceeded"));
      return;
    }
  }
};
